import { user } from './user'

export const api = {
  user,
}
